export enum CateringLinks {
    MealDefinitions = '/home/meal-definition',
    MedicalServicesAndRestrictions = '/home/medical-service',
    ScheduledMealServices = '/home/scheduled-meal-service',
    ScheduleMeal = '/home/scheduled-meal',
    SectionMealSchedulePlan = '/home/section-meal-schedule-plan',
    ScheduledPatientStation = '/home/scheduled-patient-station',
}